// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"35":"f31aec94","212":"d0deef33"}[chunkId] || chunkId) + "." + {"35":"2e568fe880b87fed","36":"e935ca1f9bc2d737","85":"c3742c60532af2a9","212":"9a6051c051181d43","228":"778bae214c45733d","305":"5433b967c08ab7c6","709":"2f4bc70a65fac0e6","795":"c0ff6803347c3703","850":"27f4622f3c5aa06f"}[chunkId] + ".js";
};